import {Stack} from '@mui/material';
import moment from "moment";
import {Datagrid, FunctionField, List, TextField, useRecordContext, useRefresh} from 'react-admin'
import CustomReferenceField from '../Common/CustomReferenceField'
import TransactionButton from '../Common/TransactionButton';
import CommonFilterCard, { CommonFilterField } from "../Common/CommonFilterCard";
import StyledDatagridWrapper, { commonDatagridSx } from "../Common/StyledDatagridWrapper";
import React, {useState} from "react";
import {RefundServiceV2} from "../../services/RefundServiceV2";
import {RefundResponseV2} from "../../interfaces/Refund/RefundResponseV2";
import {UserBundleRefundsStatus} from "../../enums/UserBundleRefundsStatus";
import EventBus from "../../EventBus";
import {EventBusEventsEnum} from "../../enums/EventBusEventsEnum";
import {PayoutDialogV2} from "./PayoutDialogV2";

const refundServiceV2 = new RefundServiceV2();

const InitiateRefund = (props: {id: number}) => {
  const refresh = useRefresh();
  const handleClick = () => {
      EventBus.emitEvent(EventBusEventsEnum.SHOW_CONFIRMATION_DIALOG, {
          message: "Are you sure to approve this refund!",
          onClose: (confirmed: boolean) => {
              if (confirmed) {
                  refundServiceV2.initiateRefundV2(props.id).then(refresh);
              }
          },
          title: "Are you sure?"
      });

  };
  return (
    <TransactionButton
      onClickHandler={handleClick}
      name={"Initiate Refund"}
    />
  );
};

const RetryRefund = (props: {id: number}) => {
  const refresh = useRefresh();
  const handleClick = () => {
      EventBus.emitEvent(EventBusEventsEnum.SHOW_CONFIRMATION_DIALOG, {
          message: "Are you sure to retry this refund!",
          onClose: (confirmed: boolean) => {
              if (confirmed) {
                  refundServiceV2.retryRefundV2(props.id).then(refresh)
              }
          },
          title: "Are you sure?"
      });

  };
  return (
    <TransactionButton
      onClickHandler={handleClick}
      name={"Retry Refund"}
    />
  );
};

const MarkAsApproved = (props: {id: number}) => {
  const refresh = useRefresh();
  const handleClick = () => {
      EventBus.emitEvent(EventBusEventsEnum.SHOW_CONFIRMATION_DIALOG, {
          message: "Are you sure to approve this refund!",
          onClose: (confirmed: boolean) => {
              if (confirmed) {
                  refundServiceV2.approveUserRefundV2(props?.id).then(refresh);
              }
          },
          title: "Are you sure?"
      });
  };
  return (
    <TransactionButton
      onClickHandler={handleClick}
      color="success"
      name={"Mark Approved"}
    />
  );
};

const MarkRejected = (props: {id: number}) => {
    const refresh = useRefresh();
    const handleClick = () => {
        EventBus.emitEvent(EventBusEventsEnum.SHOW_CONFIRMATION_DIALOG, {
            message: "Are you sure to reject this refund!",
            onClose: (confirmed: boolean) => {
                if (confirmed) {
                    refundServiceV2.rejectUserRefundV2(props?.id).then(refresh);
                }
            },
            title: "Are you sure?"
        });
    };
    return (
        <TransactionButton
            onClickHandler={handleClick}
            color="error"
            name={"Mark Rejected"}
        />
    );
};


const RenderCTAButton = (props: any) => {
  const record: RefundResponseV2 = useRecordContext();
  return (
    <Stack direction={"row"} gap={2}>
      {[UserBundleRefundsStatus.PENDING].includes(record.status) && (
          <>
              <MarkAsApproved id={record.id}  />
              <MarkRejected id={record.id}  />
          </>
      )}
      {[UserBundleRefundsStatus.APPROVED].includes(record.status) && (
        <>
            {record?.razorpayOrderId && (
                <InitiateRefund id={record.id} />
            )}
            <TransactionButton
                onClickHandler={() => {
                    props.setPayOutDialog(true);
                    props.setSelectedData(record);
                    props.setIsRetry(false);
                }}
                name={"Initiate Payout"}
            />
        </>
      )}
      {[UserBundleRefundsStatus.PROCESSING_FAILED].includes(record.status) && (
        <>
            {record?.razorpayOrderId && (
                <RetryRefund id={record.id} />
            )}
            <TransactionButton
                onClickHandler={() => {
                    props.setPayOutDialog(true);
                    props.setSelectedData(record);
                    props.setIsRetry(true);
                }}
                name={"Retry Payout"}
            />
        </>
      )}
    </Stack>
  );
};
const filterFields: CommonFilterField[] = [
    { type: "date", label: "Start Date", source: "createdAt" },
    { type: "date", label: "End Date", source: "updatedAt" },
    { type: "text", label: "Customer Phone", source: "customerPhone" },
    { type: "text", label: "Refunded By", source: "processedBy" },
    {
        type: "select",
        label: "Status",
        source: "status",
        options: Object.values(UserBundleRefundsStatus).map((key) => ({
            value: key,
            label: key,
        })),
    },
];
export const RefundListV2 = (props: RefundResponseV2) => {
    const [selectedData, setSelectedData] = useState<RefundResponseV2>();
    const [payOutDialog, setPayOutDialog] = useState<boolean>(false);
    const [isRetry, setIsRetry] = useState<boolean>(false);
  return (
      <>
          <List
              {...props}
              sx={{
                  "& .RaList-content": {
                      boxShadow: "none",
                      backgroundColor: "transparent",
                  },
              }}
          >
              <>
              <CommonFilterCard fields={filterFields} />

              <br />

              <StyledDatagridWrapper title="Refund V2">
              <Datagrid bulkActionButtons={false} sx={commonDatagridSx}>
                  <TextField source="id" />
                  <CustomReferenceField label="House" listName={"Houses"} source={"houseId"} />
                  <TextField source="customerPhone" />
                  <TextField source="amount" />
                  <TextField source="razorpayOrderId" />
                  <CustomReferenceField label="User Bundle" listName={"UserBundles"} source={"userBundleMappingId"}/>
                  <CustomReferenceField label="Refunded By" listName={"AdminUsers"} source={"processedBy"}/>
                  <TextField source="processedByEmail" />
                  <TextField source="status" />
                  <TextField source="reason" />
                  <FunctionField label="Created At" render={(record: any) => record?.createdAt ? moment(record.createdAt).format('DD MMM YYYY, hh:mm:ss A') : '-'} />
                  <FunctionField label="Updated At" render={(record: any) => record?.updatedAt ? moment(record.updatedAt).format('DD MMM YYYY, hh:mm:ss A') : '-'} />
                  <RenderCTAButton
                      setSelectedData={setSelectedData}
                      setPayOutDialog={setPayOutDialog}
                      setIsRetry={setIsRetry}
                  />
              </Datagrid>
              </StyledDatagridWrapper>
              </>
          </List>
          {selectedData && (
              <PayoutDialogV2
                  data={selectedData}
                  open={payOutDialog}
                  isRetry={isRetry}
                  callback={() => {
                      setPayOutDialog(false);
                      setSelectedData(undefined);
                  }}
              />
          )}
      </>
  )
}
